export default "__VITE_PUBLIC_ASSET__2220d2a1__"